import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RemainsTransactionOutput, RemainsTransactionsService } from 'core/http/project/remains-transactions/remains-transactions.service';
import { Observable } from 'rxjs';

@Injectable()
export class TransactionResolver {
  constructor(private remainsTransactionsService: RemainsTransactionsService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<RemainsTransactionOutput> {
    const transactionId = route.params.transactionId;
    return this.remainsTransactionsService.getTransaction(transactionId);
  }
}
